import MobileBeddingLinensSection from './MobileBeddingLinensSection';

export default MobileBeddingLinensSection;
